// Lets a customer find out — from anywhere in the app — the moment a lawyer
// confirms their booking, and jump straight into the chat that gets created
// for it. Mirrors GlobalIncomingCallBanner's "join my own room, listen from
// anywhere" pattern, just for booking status instead of calls.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { on as onHub, joinUser } from "../api/chatHub";
import { useAuth } from "../context/AuthContext";
import { getAuthUser } from "../utils/storage";

function isLawyerRole(roleType) {
  const r = String(roleType || "")
    .toLowerCase()
    .trim();
  return ["agent", "lawyer", "advocate"].includes(r);
}

export default function GlobalBookingNotifications() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const authUser = user || getAuthUser();
  const selfId = authUser?.userId || authUser?.id || null;
  const lawyer = isLawyerRole(authUser?.roleType || authUser?.role);

  useEffect(() => {
    // Only customers book lawyers, so only customers need to hear back —
    // the lawyer's own side (AgentBookings) already shows "NewBooking" live.
    if (!selfId || lawyer) return undefined;
    joinUser(selfId).catch(() => {});

    const offStatus = onHub("BookingStatusChanged", (payload) => {
      if (!payload) return;
      if (payload.status === "Confirmed") {
        toast(
          (t) => (
            <div className="toast-booking-confirmed">
              <span>Your booking has been confirmed!</span>
              {payload.agentId && (
                <button
                  onClick={() => {
                    toast.dismiss(t.id);
                    navigate(`/chat/${payload.agentId}`);
                  }}
                  className="toast-booking-btn"
                >
                  Open Chat
                </button>
              )}
            </div>
          ),
          { duration: 10000 },
        );
      } else if (payload.status === "Cancelled") {
        toast.error("Your booking request was declined.");
      }
    });

    return () => offStatus();
  }, [selfId, lawyer, navigate]);

  return null;
}
